<dx-data-grid #table [dataSource]="emailTemplates" [rowAlternationEnabled]="true" [showBorders]="true" [columnAutoWidth]="true" [showRowLines]="false" [showColumnLines]="false" [hoverStateEnabled]="true"
                [allowColumnResizing]="true"
[allowColumnReordering]="true"
                columnResizingMode="nextColumn" (onToolbarPreparing)="onToolbarPreparing($event)">
    <dxo-remote-operations [filtering]="true" [paging]="true" [sorting]="true"></dxo-remote-operations>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-paging [pageSize]="15"></dxo-paging>
    <dxo-pager [showInfo]="true"></dxo-pager>
    <!-- <dxo-editing mode="single" [allowUpdating]="canUpdate" [allowDeleting]="canUpdate" [allowAdding]="canUpdate"></dxo-editing> -->

    <dxi-column dataField="key" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.TEMPLATE' | translate">
        <dxo-lookup [dataSource]="emailTemplateKeys" valueExpr="value" displayExpr="label"></dxo-lookup>
    </dxi-column>
    <dxi-column dataField="subject" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'COMPANIES.EMAIL_SUBJECT' | translate"></dxi-column>
    <dxi-column dataField="body" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'COMPANIES.EMAIL_BODY' | translate"></dxi-column>
    <dxi-column dataField="attachmentLink" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'COMPANIES.EMAIL_ATTACHMENT_LINK' | translate"></dxi-column>
    <dxi-column *ngIf="default" dataField="description" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.DESCRIPTION' | translate"></dxi-column>

    <dxi-column cellTemplate="actionsTemplate" *ngIf="canUpdate"[allowFiltering]="false" [allowSorting]="false" [fixed]="true" fixedPosition="right" [width]="70" [caption]="''" [cssClass]="'actions'"></dxi-column>

    <div *dxTemplate="let template of 'actionsTemplate'">
        <span class="table-icon ti-eye" [matTooltip]="'SHARED.VIEW' | translate" matTooltipPosition="above" matTooltipHideDelay="200" (click)="edit(template.data)"></span>
        <span *ngIf="canUpdate && !default" class="table-icon dx-icon-trash" [matTooltip]="'SHARED.DELETE' | translate" matTooltipPosition="above" matTooltipHideDelay="200" (click)="delete(template.data.key)"></span>
        <span *ngIf="canUpdate && default" class="table-icon dx-icon-trash" [matTooltip]="'SHARED.DELETE' | translate" matTooltipPosition="above" matTooltipHideDelay="200" (click)="delete(template.data.id)"></span>
    </div>
</dx-data-grid>

<dx-popup width="1000px" maxWidth="100%" maxHeight="100%" [(visible)]="isEmailTemplateFormVisible" showCloseButton="true" [title]="emailTemplatePopupTitle" (onHiding)="closeEmailTemplateFormModal()">
    <dx-scroll-view height="85.5%" minHeight="85.5%">
        <div class="row">
            <div class="dx-field-label">{{ 'SHARED.TEMPLATE' | translate}}</div>
        </div>
        <div class="row">
            <dx-select-box data-cy="emailTemplateKeys" [dataSource]="emailTemplateKeys" valueExpr="value" displayExpr="label" searchEnabled="true" [(value)]="key" [readOnly]="!canUpdate">
                <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
            </dx-select-box>
        </div>
        <br>
        <div class="row">
            <div class="dx-field-label">{{ 'COMPANIES.EMAIL_SUBJECT' | translate}}</div>
        </div>
        <div class="row">
            <dx-text-box data-cy="subject-input" valueChangeEvent="keyup" [(value)]="subject" [maxLength]="100" [readOnly]="!canUpdate">
                <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
            </dx-text-box>
        </div>
        <br>
        <div class="row">
            <div class="dx-field-label">{{ 'COMPANIES.EMAIL_BODY' | translate}}</div>
        </div>
        <div class="row">
            <dx-text-area data-cy="content" [height]="'40vh'" [(value)]="body" [readOnly]="!canUpdate">
            </dx-text-area>
                <!-- <dx-html-editor [(value)]="body" class="form-panel" height="40vh" [readOnly]="!canUpdate">
                    <dxo-toolbar>
                        <dxi-item formatName="undo"></dxi-item>
                        <dxi-item formatName="redo"></dxi-item>
                        <dxi-item formatName="separator"></dxi-item>
                        <dxi-item formatName="size"
                            [formatValues]="['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']"></dxi-item>
                        <dxi-item formatName="font"
                            [formatValues]="['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana']">
                        </dxi-item>
                        <dxi-item formatName="separator"></dxi-item>
                        <dxi-item formatName="bold"></dxi-item>
                        <dxi-item formatName="italic"></dxi-item>
                        <dxi-item formatName="strike"></dxi-item>
                        <dxi-item formatName="underline"></dxi-item>
                        <dxi-item formatName="separator"></dxi-item>
                        <dxi-item formatName="alignLeft"></dxi-item>
                        <dxi-item formatName="alignCenter"></dxi-item>
                        <dxi-item formatName="alignRight"></dxi-item>
                        <dxi-item formatName="alignJustify"></dxi-item>
                        <dxi-item formatName="separator"></dxi-item>
                        <dxi-item formatName="orderedList"></dxi-item>
                        <dxi-item formatName="bulletList"></dxi-item>
                        <dxi-item formatName="separator"></dxi-item>
                        <dxi-item formatName="header" [formatValues]="[false, 1, 2, 3, 4, 5]"></dxi-item>
                        <dxi-item formatName="separator"></dxi-item>
                        <dxi-item formatName="color"></dxi-item>
                        <dxi-item formatName="background"></dxi-item>
                        <dxi-item formatName="separator"></dxi-item>
                        <dxi-item formatName="link"></dxi-item>
                        <dxi-item formatName="image"></dxi-item>
                        <dxi-item formatName="separator"></dxi-item>
                        <dxi-item formatName="clear"></dxi-item>
                        <dxi-item formatName="codeBlock"></dxi-item>
                        <dxi-item formatName="blockquote"></dxi-item>
                    </dxo-toolbar>
                    <dxo-media-resizing [enabled]="true">
                    </dxo-media-resizing>
                </dx-html-editor> -->
        </div>
        <br>
        <div class="row">
            <div class="dx-field-label">{{ 'COMPANIES.EMAIL_ATTACHMENT_LINK' | translate}}</div>
        </div>
        <div class="row">
            <dx-text-box valueChangeEvent="keyup" [(value)]="attachmentLink" [maxLength]="100" [readOnly]="!canUpdate">
                <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
            </dx-text-box>
        </div>
        <br *ngIf="default">
        <div *ngIf="default" class="row">
            <div class="dx-field-label">{{ 'SHARED.DESCRIPTION' | translate}}</div>
        </div>
        <div *ngIf="default" class="row">
            <dx-text-box valueChangeEvent="keyup" [(value)]="description" [maxLength]="100"></dx-text-box>
        </div>
    </dx-scroll-view>
    <hr>
    <div class="dx-popup-footer">
        <div class="row col-sm-8 offset-sm-2 col-12 offset-0">
            <div class="col">
                <dx-button data-cy="save-changes" class="navbar-button btn-block" [height]="32" stylingMode="contained" icon="save" [text]="'SHARED.SAVE_CHANGES' | translate" type="success" (onClick)="saveEmailTemplate()" [disabled]="!canUpdate"></dx-button>
            </div>
            <div class="col">
                <dx-button data-cy="close" class="navbar-button btn-block" [height]="32" stylingMode="outlined" icon="close" [text]="'SHARED.CLOSE' | translate" type="normal" (onClick)="closeEmailTemplateFormModal()"></dx-button>
            </div>
        </div>
    </div>
</dx-popup>

<!-- {{ 'ENUMS.EMAIL_TEMPLATE_KEYS.USER_REQUEST_PASSWORD_FORGOT ' | translate }} -->